import { useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import {
  QUERY_PARAMS,
  matchOnboardingBudgetRoute,
  matchOnboardingRoute,
  matchOnboardingScenarioRoute,
  matchOnboardingScenarioWithInvoicesRoute
} from '@futrli/shared-services';

import { getAllNodesRefs } from '../../detail/predictions/util-fns/consolidation-util-fns';
import { UserGridSettingsContext } from '../../detail/reports/user-grid-settings/user-grid-settings-context';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const useExpandAllRows = () => {
  const { forecastReportV2 } = usePredictionsInfoContext();
  const { clearExpandedRows, toggleExpandedRows } = useContext(UserGridSettingsContext);

  useEffect(() => {
    if (!forecastReportV2) {
      return;
    }

    clearExpandedRows();
    toggleExpandedRows(...getAllNodesRefs(forecastReportV2));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forecastReportV2]);
};

export const useOnboardingUrlInfo = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const forecastType = searchParams.get(QUERY_PARAMS.FORECAST_TYPE);
  const editInvoicesBills = searchParams.get(QUERY_PARAMS.EDIT_INVOICES_BILLS);
  const onboardingForecastId = searchParams.get(QUERY_PARAMS.ONBOARDING_FORECAST_ID);

  const { onboardingStep: tempOnboardingStep } = useParams();

  return {
    forecastType,
    onboardingStep: tempOnboardingStep || '',
    editInvoicesBills,
    onboardingForecastId,
    isOnboardingRoute: !!matchOnboardingRoute(location.pathname),
    isOnboardingScenarioRoute: !!matchOnboardingScenarioRoute(location.pathname),
    isOnboardingBudgetRoute: !!matchOnboardingBudgetRoute(location.pathname),
    isOnboardingScenarioWithInvoicesRoute: !!matchOnboardingScenarioWithInvoicesRoute(location.pathname)
  };
};

const ANIMATION_LATENCY_MS = 300;

export const useAnimationLatency = (canDisplayArrow?: boolean) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    let timerId: ReturnType<typeof setTimeout>;

    if (canDisplayArrow) {
      timerId = setTimeout(() => {
        setShowContent(true);
      }, ANIMATION_LATENCY_MS);
    }

    return () => {
      clearTimeout(timerId);
      setShowContent(false);
    };
  }, [canDisplayArrow]);

  return showContent;
};
